








import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import PopupEnd from '@/views/templates/kuntama/PopupEnd.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    PopupEnd
  }

  data: () ->
    fire_scroll: true
    showPopup: 0

  created: () ->
    @$options.scroll_target = '.episode11'

  methods:
    scrollFire: (e) ->
      if @showPopup == 0
        @showPopup = 1
    close_end_popup: ()->
      @showPopup = 2
    add_point: (point) ->
      @$emit('addPoint', point)

